// extracted by mini-css-extract-plugin
module.exports = {"component":"CloseButton_component__3_1_t"};